(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/flows/recipient-picker/views/wait/template', '<div class="recipient-picker">WAIT</div>\n' + '');
}]);
})();